import { Bell } from 'lucide-react'
import { useUnreadCount } from '@/hooks/useUnreadCount'

export function NotificationBadge({ onClick }: { onClick: () => void }) {
  const { data: count = 0 } = useUnreadCount()

  return (
    <button
      onClick={onClick}
      className="p-2 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg relative"
      aria-label={count > 0 ? `${count} neprečítaných notifikácií` : 'Notifikácie'}
    >
      <Bell size={18} />
      {count > 0 && (
        <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center">
          {count > 9 ? '9+' : count}
        </span>
      )}
    </button>
  )
}
